var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            title: _vm.$t("pages.admin.livestream.announcements.index.title"),
            "icon-class": "mdi mdi-record"
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-primary font-weight-bold",
                  attrs: {
                    tag: "a",
                    to: { name: "admin.livestream.announcement.add" }
                  }
                },
                [
                  _c("i", { staticClass: "mdi mdi-plus" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("actions.create")) + "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card shadow-sm" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("h5", { staticClass: "card-title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "pages.admin.livestream.announcements.index.title_upcoming"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("announcement-table", {
              attrs: {
                announcements: _vm.announcementsUpcoming,
                "empty-text": _vm.$t(
                  "pages.admin.livestream.announcements.index.no_upcoming"
                )
              },
              on: { reload: _vm.getUpcomingAnnouncements }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("pagination", {
                  attrs: { data: _vm.paginationDataUpcoming },
                  on: { "pagination-change-page": _vm.getUpcomingAnnouncements }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mt-3" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("h5", { staticClass: "card-title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "pages.admin.livestream.announcements.index.title_past"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("announcement-table", {
              attrs: {
                announcements: _vm.announcementsPast,
                "empty-text": _vm.$t(
                  "pages.admin.livestream.announcements.index.no_past"
                )
              },
              on: { reload: _vm.getPastAnnouncements }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("pagination", {
                  attrs: { data: _vm.paginationDataPast },
                  on: { "pagination-change-page": _vm.getPastAnnouncements }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }